import React, { useState, useEffect } from "react";
import { connect, useSelector } from "react-redux";
import PropTypes from "prop-types";
import clsx from "clsx";
import { Formik } from "formik";
import { createTheme } from "@material-ui/core";
import moment from 'moment';
import { bindActionCreators } from 'redux';
import {
  Card,
  CardContent,
  CardActions,
  Grid,
  Typography,
  TextField,
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import {
  updateSimuSetting,
  updateMakeRandomEVData,
  updateChgrCnt
} from "actions/settings";
import firebase from '../../../../Firebase';
import { getDatabase, ref, onValue, get, child } from 'firebase/database';

import i18n from 'i18n/i18n';  // i18n 객체 직접 import
import 'intl-pluralrules';


const COLUMN_WIDTH = {
  NO: "4%",
  ON_TIME: '22%',
  OFF_TIME: '22%',
  DESIRED_DRIVING_DISTANCE: '16%',
  CURRENT_AVAILABLE_DISTANCE: '16%',
  EV_MODEL: '20%',
}


// const ev_model_list =  ['아이오닉5', 'EV6', '포터2 일렉트릭', '봉고3 EV',
//                         '아이오닉6', '넥쏘', '니로 EV', '테슬라 모델3', '테슬라 모델Y',
//                       '제네시스 GV60', '포르쉐 타이칸'];


const CustomTableCell = ({ row, name, onChange, width, label, _align }) => {
  const classes = useStyles();

  if (row) {
    return (
      // <TableCell align="right" width={width} className={classes.tablecell}>
      <TableCell align="left" width={width} className={classes.tablecell}>
        <TextField
          siz="size"
          variant="outlined"
          name={name}
          // label={label}
          fullWidth
          // align={align || 'right'}
          value={row[name]}
          onChange={onChange}

          inputProps={{
            style: {
              fontSize: '0.9em',
              // textAlign: "right",
              textAlign: _align || "right",
              paddingBlock: 4,
              // paddingLeft: 6,
              paddingInline: 6,
            },
            // maxLength: 20,
          }}
        />
      </TableCell>
    );
  } else {
    return (<TableCell></TableCell>);
  }
};




const EVParamInput = (props) => {
  const { className, history, simuSettings, ...rest } = props;
  const classes = useStyles();

  const selector_random_ev_data = useSelector((state) => state.simuSettings.random_ev_data);

  const [firstHalf, setFirstHalf] = useState(0);

  const [evlist, setEvlist] = useState([]);

  const database = getDatabase();
  const dbRef = ref(database);

  const handleChange = (event, index) => {
    const val = event.target.value;
    const name = event.target.name;

    let newArr = [...evlist];
    newArr[index][name] = val;
    setEvlist(newArr);

    props.updateMakeRandomEVData(newArr);
  }


  // const makeEvData = () => {
  //   let start_t = moment();

  //   let datas = [];
  //   for (var i = 0; i < 12; i++) {

  //     const model_random = (10 * Math.random()).toFixed(0);
  //     const leave_random = (6 * Math.random()).toFixed(0);

  //     datas.push({
  //       id: i,
  //       on_time: start_t.format('YY/MM/DD HH:mm'),
  //       off_time: start_t.add(leave_random, 'hours').format('YY/MM/DD HH:mm'),
  //       desired_driving_dis: Math.floor(Math.random() * 200) + 3,
  //       current_avail_dis: Math.floor(Math.random() * 100) + 51,
  //       ev_model: ev_model_list[ model_random ]
  //     });

  //     start_t = start_t.add( model_random, 'minutes');
  //   }


  //   setEvlist(datas);
  // }


  useEffect(() => {

    if (selector_random_ev_data.length >= 0) {

      // console.log(Math.ceil(selector_random_ev_data.length/2));

      setFirstHalf(Math.ceil(selector_random_ev_data.length / 2));
      setEvlist(selector_random_ev_data);
    }
  }, [selector_random_ev_data]);
  //이건 화면이 expose된 상태에서만 작동함.




  useEffect(() => {
    // makeEvData();


    onValue(child(dbRef, 'simu/params'), (snapshot) => {

      let datas = [];
      let max_chgr = 0;

      snapshot.forEach(function (childSnapshot) {

        datas.push(childSnapshot.val());
        max_chgr += 1;

        // if (childSnapshot.key === "total_charge_amount_ratio") {
        //   setLCAmountRatio( childSnapshot.val()  );
        // }
        // else if(childSnapshot.key === "lc_max_profile"){
        //   setMaxProfile( (childSnapshot.val() / 1000).toFixed(1) );
        // }
      });

      props.updateMakeRandomEVData(datas);
      props.updateChgrCnt(max_chgr);
    });

    // let start_t = moment().add(10 + Math.round(Math.random() * 10), 'minutes');

    // for (var i = 0; i < max_chgr; i++) {

    //   const model_random = (10 * Math.random()).toFixed(0);
    //   const leave_random = (15 * Math.random()).toFixed(0); //최대 5시간
    //   // const start_random = (60 * Math.random()).toFixed(0); //최대 60분
    //   const start_random = (11 * Math.random()).toFixed(0); //최대 10분
    //   console.log(start_random);

    //   datas.push({
    //     idx: i,
    //     chgr_id: String(i + 1).padStart(2, '0'),
    //     on_time: start_t.format('YY/MM/DD HH:mm'),
    //     off_time: moment(start_t).add(leave_random + 1, 'minutes').format('YY/MM/DD HH:mm'),
    //     current_avail_dis: Math.floor(Math.random() * 100) + 41,
    //     desired_driving_dis: Math.floor(Math.random() * 70) + 153,
    //     ev_model: ev_model_list[model_random],
    //     profile:0,
    //     isNew: false,
    //     isActive: false
    //   });

    //   console.log("start_t1:", start_t);
    //   start_t.add(start_random, 'minutes');
    //   console.log("start_t2:", start_t);
    // }

  }, []);


  return (

    <div>
      <Grid container spacing={1}>

        <Grid container item md={6} xs={6} >
          <Table size="small"
            style={{
              borderLeft: '1px solid #e0e0e0',
              borderTop: '1px solid #e0e0e0',
              borderRight: '1px solid #e0e0e0'
            }}>
            <TableHead>
              <TableRow>
                <TableCell align="center" width={COLUMN_WIDTH.NO}>{i18n.t("no")}</TableCell>
                <TableCell siz="small" align="center" width={COLUMN_WIDTH.ON_TIME}>{i18n.t("time_in")}</TableCell>
                <TableCell align="center" width={COLUMN_WIDTH.OFF_TIME}>{i18n.t("time_to_leave")}</TableCell>
                <TableCell align="center" width={COLUMN_WIDTH.CURRENT_AVAILABLE_DISTANCE}><Typography variant="caption">{i18n.t("current_range")}[km]</Typography></TableCell>
                <TableCell align="center" width={COLUMN_WIDTH.DESIRED_DRIVING_DISTANCE}><Typography variant="caption">{i18n.t("desired_range")}[km]</Typography></TableCell>
                <TableCell align="center" width={COLUMN_WIDTH.EV_MODEL}>{i18n.t("vehicle_model")}</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {evlist.slice(0, firstHalf).map((module, index) => (
                <TableRow className={classes.tableRow} key={module.chgr_id}>
                  <TableCell align="center" width={COLUMN_WIDTH.NO} className={classes.tablecell}>{module.chgr_id}</TableCell>

                  <CustomTableCell {...{
                    row: module, name: "on_time", onChange: (e => handleChange(e, index)),
                    width: COLUMN_WIDTH.ON_TIME, label: 'conn time', _align: 'left',
                  }} />
                  <CustomTableCell {...{
                    row: module, name: "off_time", onChange: (e => handleChange(e, index)),
                    width: COLUMN_WIDTH.OFF_TIME, label: 'discon time', _align: 'left',
                  }} />
                  <CustomTableCell {...{
                    row: module, name: "current_avail_dis", onChange: (e => handleChange(e, index)),
                    width: COLUMN_WIDTH.CURRENT_AVAILABLE_DISTANCE, label: 'CUR mileage'
                  }} />
                  <CustomTableCell {...{
                    row: module, name: "desired_driving_dis", onChange: (e => handleChange(e, index)),
                    width: COLUMN_WIDTH.DESIRED_DRIVING_DISTANCE, label: 'hope mileage'
                  }} />
                  <CustomTableCell {...{
                    row: module, name: "ev_model", onChange: (e => handleChange(e, index)),
                    width: COLUMN_WIDTH.EV_MODEL, label: 'model', _align: 'left',
                  }} />
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Grid>



        <Grid container item md={6} xs={6} >
          <Table size="small"
            style={{
              borderLeft: '1px solid #e0e0e0',
              borderTop: '1px solid #e0e0e0',
              borderRight: '1px solid #e0e0e0'
            }}>
            <TableHead>
              <TableRow>
                <TableCell align="center" width={COLUMN_WIDTH.NO}>{i18n.t("no")}</TableCell>
                {/* <TableCell align="center" width={COLUMN_WIDTH.ON_TIME}>연결시각</TableCell>
              <TableCell align="center" width={COLUMN_WIDTH.OFF_TIME}>연결해제시각</TableCell>
              <TableCell align="center" width={COLUMN_WIDTH.CURRENT_AVAILABLE_DISTANCE}>현재주행가능거리</TableCell>
              <TableCell align="center" width={COLUMN_WIDTH.DESIRED_DRIVING_DISTANCE}>최소희망주행거리</TableCell>
              <TableCell align="center" width={COLUMN_WIDTH.EV_MODEL}>차량모델</TableCell> */}
                <TableCell siz="small" align="center" width={COLUMN_WIDTH.ON_TIME}>{i18n.t("time_in")}</TableCell>
                <TableCell align="center" width={COLUMN_WIDTH.OFF_TIME}>{i18n.t("time_to_leave")}</TableCell>
                <TableCell align="center" width={COLUMN_WIDTH.CURRENT_AVAILABLE_DISTANCE}><Typography variant="caption">{i18n.t("current_range")}[km]</Typography></TableCell>
                <TableCell align="center" width={COLUMN_WIDTH.DESIRED_DRIVING_DISTANCE}><Typography variant="caption">{i18n.t("desired_range")}[km]</Typography></TableCell>
                <TableCell align="center" width={COLUMN_WIDTH.EV_MODEL}>{i18n.t("vehicle_model")}</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {evlist.slice(firstHalf, evlist.length).map((module, index) => (
                <TableRow className={classes.tableRow} key={module.chgr_id}>

                  <TableCell align="center" width={COLUMN_WIDTH.NO} className={classes.tablecell}>{module.chgr_id}</TableCell>

                  <CustomTableCell {...{
                    row: module, name: "on_time", onChange: (e => handleChange(e, firstHalf + index)),
                    width: COLUMN_WIDTH.ON_TIME, label: 'conn time', _align: 'left',
                  }} />
                  <CustomTableCell {...{
                    row: module, name: "off_time", onChange: (e => handleChange(e, firstHalf + index)),
                    width: COLUMN_WIDTH.OFF_TIME, label: 'discon time', _align: 'left',
                  }} />
                  <CustomTableCell {...{
                    row: module, name: "current_avail_dis", onChange: (e => handleChange(e, firstHalf + index)),
                    width: COLUMN_WIDTH.CURRENT_AVAILABLE_DISTANCE, label: 'CUR mileage'
                  }} />
                  <CustomTableCell {...{
                    row: module, name: "desired_driving_dis", onChange: (e => handleChange(e, firstHalf + index)),
                    width: COLUMN_WIDTH.DESIRED_DRIVING_DISTANCE, label: 'hope mileage'
                  }} />
                  <CustomTableCell {...{
                    row: module, name: "ev_model", onChange: (e => handleChange(e, firstHalf + index)),
                    width: COLUMN_WIDTH.EV_MODEL, label: 'model', _align: 'left',
                  }} />

                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Grid>
      </Grid>

    </div>

  );
}


EVParamInput.propTypes = {
  className: PropTypes.string,
  history: PropTypes.object,
};


const mapDispatchToProps = dispatch => {
  return bindActionCreators({
    updateSimuSetting,
    updateMakeRandomEVData,
    updateChgrCnt,
  }, dispatch);
};

let mapStateToProps = (state) => {
  return { simuSettings: state.simuSettings }
}

// export default EVParamInput;
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EVParamInput);



const theme = createTheme({
  spacing: 4,
})

const useStyles = makeStyles(() => ({
  root: {
    padding: theme.spacing(1),
  },


  tablecell: {
    "&.MuiTableCell-root": {
      padding: '6px',
    },
  },
  tableRow: {
    // height: "10px",
    // padding : "10px",
  },
  textfield: {
    "&.MuiOutlinedInput-input": {
      // padding: '4px'
    }
  },



  content: {
    marginTop: theme.spacing(0),
  },
  action: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
    "& + &": {
      marginLeft: theme.spacing(1),
    },
  },

  queryField: {
    flexBasis: 220,
    marginRight: 20,
  },
  bulkAction: {
    marginLeft: theme.spacing(2),
  },

  divider: {
    margin: theme.spacing(2, 0)
  },
}));